var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('label',{staticClass:"label has-text-light"},[_vm._v("Label Farbe")]),_vm._l((_vm.available),function(a){return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-circle",class:[a === _vm.color ? 'selected' : ''],style:({'color':a}),on:{"click":function($event){return _vm.updateParent(a)}}})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }